import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="section bg-light">
      <div className="container">
        <h2 className="section-title">Privacy Policy</h2>
        <p>
          This Privacy Policy applies to the CompileX website and the Game Dorm brand. It explains how we collect, use, and protect information when you interact with our website or our games.
        </p>

        <h3>Information We Collect</h3>
        <ul>
          <li>Contact details and inquiry information you submit through website forms.</li>
          <li>Device and usage data collected for app performance, crash reporting, and analytics.</li>
          <li>Technical data such as operating system, device model, and browsing behavior.</li>
        </ul>

        <h3>How We Use Your Information</h3>
        <ul>
          <li>To respond to inquiries and provide support.</li>
          <li>To improve the website, games, and user experience.</li>
          <li>To analyze performance, diagnose issues, and maintain security.</li>
        </ul>

        <h3>Third-Party Services</h3>
        <p>
          We may use service providers for analytics, hosting, email, and app distribution. These providers only receive the information necessary to perform their services.
        </p>

        <h3>Data Sharing</h3>
        <p>
          We do not sell your personal information. We may share data when required by law or to protect our rights, and with service providers who help us operate the website and games.
        </p>

        <h3>Cookies and Tracking</h3>
        <p>
          Our website may use cookies or similar technologies to remember preferences, improve navigation, and understand usage patterns.
        </p>

        <h3>Security</h3>
        <p>
          We use reasonable measures to protect your information, but no system is completely secure.
        </p>

        <h3>Children's Privacy</h3>
        <p>
          The website and Game Dorm are not intended for children under 13. If we learn that we have collected personal information from a child under 13, we will take steps to delete it.
        </p>

        <h3>Changes to This Policy</h3>
        <p>
          We may update this policy from time to time. The latest version will always be available on this website.
        </p>

        <h3>Contact</h3>
        <p>
          If you have questions about this privacy policy, please contact us at <a href="mailto:contact@compilex.com">contact@compilex.com</a>.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
